import { makeModel } from "./crudModel";
import { currentJobModel as currentJobModels } from "./currentJobModel";

export const currentJobModel = currentJobModels("currentJob");
export const example = makeModel("example");
export const perfil = makeModel("perfil");

export { default as sso } from "./ssoModel";
export { default as agenda } from "./agendaModel";
